import { render, staticRenderFns } from "./ArticleComoRastrearCliques.vue?vue&type=template&id=3336df71&"
import script from "./ArticleComoRastrearCliques.vue?vue&type=script&lang=js&"
export * from "./ArticleComoRastrearCliques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports